import { Resource } from "../resource/resource.model";

/**
 * 4Bridge Connector Metadata Model
 * Represents metadata about a connector type (Salesforce, Marketo, etc.)
 */
export class BridgeConnectorMetadata extends Resource {
    connectorType: string;
    displayName: string;
    description?: string;
    iconUrl?: string;
    supportedAuthTypes: string[];
    requiredCredentialFields: CredentialField[];
    optionalCredentialFields: CredentialField[];
    supportedObjects: ConnectorObject[];
    isEnabled: boolean;
    version?: string;
    documentationUrl?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

/**
 * Credential field definition
 */
export interface CredentialField {
    name: string;
    label: string;
    type: string;
    isRequired: boolean;
    isSecret: boolean;
    description?: string;
    placeholder?: string;
    validationPattern?: string;
    validationMessage?: string;
}

/**
 * Connector object definition
 */
export interface ConnectorObject {
    name: string;
    label: string;
    description?: string;
    fields: ObjectField[];
    supportsCreate: boolean;
    supportsRead: boolean;
    supportsUpdate: boolean;
    supportsDelete: boolean;
}

/**
 * Object field definition
 */
export interface ObjectField {
    name: string;
    label: string;
    type: string;
    isRequired: boolean;
    isReadOnly: boolean;
    description?: string;
}

/**
 * Request DTO for creating connector metadata
 */
export interface CreateConnectorMetadataRequest {
    connectorType: string;
    displayName: string;
    description?: string;
    iconUrl?: string;
    supportedAuthTypes: string[];
    requiredCredentialFields: CredentialField[];
    optionalCredentialFields: CredentialField[];
    supportedObjects: ConnectorObject[];
    isEnabled?: boolean;
    version?: string;
    documentationUrl?: string;
}

/**
 * Request DTO for updating connector metadata
 */
export interface UpdateConnectorMetadataRequest {
    displayName?: string;
    description?: string;
    iconUrl?: string;
    supportedAuthTypes?: string[];
    requiredCredentialFields?: CredentialField[];
    optionalCredentialFields?: CredentialField[];
    supportedObjects?: ConnectorObject[];
    isEnabled?: boolean;
    version?: string;
    documentationUrl?: string;
}

/**
 * Field type enum
 */
export enum FieldType {
    STRING = 'string',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    DATE = 'date',
    DATETIME = 'datetime',
    EMAIL = 'email',
    URL = 'url',
    PASSWORD = 'password',
    TEXTAREA = 'textarea',
    SELECT = 'select'
}
